/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Benefit_FooterInputs */

const en_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Based on Forest’s internal data`)
};

const ar_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*استنادًا إلى بيانات Forest الداخلية`)
};

const de_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Basierend auf den internen Daten von Forest`)
};

const es_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Basado en datos internos de Forest`)
};

const fr_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Sur la base des données internes de Forest`)
};

const it_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Basato sui dati interni di Forest`)
};

const ja_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Forest内部データに基づく`)
};

const ko_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Forest의 내부 데이터 기반`)
};

const pt_br_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Baseado nos dados internos do Forest`)
};

const ru_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*На основе внутренних данных Forest`)
};

const th_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*อ้างอิงจากข้อมูลภายในของ Forest`)
};

const tr_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*Forest'ın dahili verilerine dayanmaktadır`)
};

const zh_cn_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*以上数据来自 Forest 内部资料`)
};

const zh_tw_onboarding_paywall_benefit_footer = /** @type {(inputs: Onboarding_Paywall_Benefit_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*以上數據來自 Forest 內部資料`)
};

/**
* | output |
* | --- |
* | "*Based on Forest’s internal data" |
*
* @param {Onboarding_Paywall_Benefit_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_benefit_footer = /** @type {((inputs?: Onboarding_Paywall_Benefit_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Benefit_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_benefit_footer(inputs)
	if (locale === "ar") return ar_onboarding_paywall_benefit_footer(inputs)
	if (locale === "de") return de_onboarding_paywall_benefit_footer(inputs)
	if (locale === "es") return es_onboarding_paywall_benefit_footer(inputs)
	if (locale === "fr") return fr_onboarding_paywall_benefit_footer(inputs)
	if (locale === "it") return it_onboarding_paywall_benefit_footer(inputs)
	if (locale === "ja") return ja_onboarding_paywall_benefit_footer(inputs)
	if (locale === "ko") return ko_onboarding_paywall_benefit_footer(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_benefit_footer(inputs)
	if (locale === "ru") return ru_onboarding_paywall_benefit_footer(inputs)
	if (locale === "th") return th_onboarding_paywall_benefit_footer(inputs)
	if (locale === "tr") return tr_onboarding_paywall_benefit_footer(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_benefit_footer(inputs)
	return zh_tw_onboarding_paywall_benefit_footer(inputs)
});